import React from "react";
import Table from "@material-ui/core/Table";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import styles from "./styles";
import { withStyles } from "@material-ui/core/styles";
import {
  getTotalDeliveryStops,
  getTotalCompletedDeliveryStops,
  completedVsTotalStopsFormatter,
} from "../../utils/utils";
import Select from "react-select";
import ArrowDropDown from "@material-ui/icons/KeyboardArrowDown";
import { ALL_DRIVER_STATUS } from "../constants";

const Details = withStyles(styles)(function ({
  classes,
  routeData,
  latestLunchBreak,
  currentDriverRoutes,
  changeRouteData,
}) {
  const getDropdownOptions = (key) => {
    return currentDriverRoutes.map((route) => {
      return { label: route[key], value: route.routeId };
    });
  };

  const totalDeliveryStops = getTotalDeliveryStops(routeData.stops);
  const currentDriverRouteNames = getDropdownOptions("routeName");
  const currentDriverManifests = getDropdownOptions("manifestNumber");
  const currentDriverTrailers = getDropdownOptions("trailerNumber");
  const totalCompletedDeliveryStops = getTotalCompletedDeliveryStops(
    routeData.stops
  );
  const arrivalLunchTime = latestLunchBreak?.startTime;
  const departureLunchTime = latestLunchBreak?.endTime
    ? latestLunchBreak.endTime
    : "";
  return (
    <Table size="small">
      <TableBody>
        <TableRow className={classes.tableRow}>
          <TableCell className={classes.tableHeaderCell}>Trip #</TableCell>
          <TableCell className={classes.tableHeaderCell}>Stops</TableCell>
          <TableCell className={classes.tableHeaderCell}>Route</TableCell>
        </TableRow>
        <TableRow className={classes.tableRow}>
          <TableCell className={classes.enrouteTo}>
            {routeData.tripNumber}
          </TableCell>
          <TableCell className={classes.tableDataCell}>
            {completedVsTotalStopsFormatter(routeData)}
          </TableCell>
          <TableCell className={classes.tableDataCell}>
            {currentDriverManifests.length > 1 ? (
              <Select
                classNamePrefix={"select"}
                className={classes.driverPopupSelect}
                value={{ label: routeData.routeName, value: routeData.routeId }}
                onChange={changeRouteData}
                menuPlacement="auto"
                menuPosition="absolute"
                closeMenuOnSelect
                isDisabled={currentDriverRouteNames.length === 1}
                components={{
                  DropdownIndicator: (props) => (
                    <ArrowDropDown
                      {...props.innerProps}
                      className={classes.iconStyle}
                    />
                  ),
                }}
                options={currentDriverRouteNames}
              />
            ) : (
              routeData.routeName
            )}
          </TableCell>
        </TableRow>
        <TableRow className={classes.tableRow}>
          <TableCell className={classes.tableHeaderCell}>Manifest #</TableCell>
          <TableCell className={classes.tableHeaderCell}>
            Gate Out - In
          </TableCell>
          <TableCell className={classes.tableHeaderCell}>Deliveries</TableCell>
        </TableRow>
        <TableRow className={classes.tableRow}>
          <TableCell className={classes.tableDataCell}>
            {currentDriverManifests.length > 1 ? (
              <Select
                classNamePrefix={"select"}
                className={classes.driverPopupSelect}
                value={{
                  label: routeData.manifestNumber,
                  value: routeData.routeId,
                }}
                onChange={changeRouteData}
                menuPlacement="auto"
                menuPosition="absolute"
                closeMenuOnSelect
                isDisabled={currentDriverManifests.length === 1}
                components={{
                  DropdownIndicator: (props) => (
                    <ArrowDropDown
                      {...props.innerProps}
                      className={classes.iconStyle}
                    />
                  ),
                }}
                options={currentDriverManifests}
              />
            ) : (
              routeData.manifestNumber
            )}
          </TableCell>
          <TableCell className={classes.tableDataCell}>
            {routeData.gateOutTime && routeData.gateInTime && (
              <>
                {`${routeData.gateOutTime} - ${
                  routeData.routeStatus === ALL_DRIVER_STATUS.ArrivedAtTerminal
                    ? routeData.gateInTime
                    : ""
                }`}
              </>
            )}
          </TableCell>

          <TableCell className={classes.tableDataCell}>
            {`${totalCompletedDeliveryStops}/${totalDeliveryStops}`}
          </TableCell>
        </TableRow>
        <TableRow className={classes.tableRow}>
          <TableCell className={classes.tableHeaderCell}>Trailer #</TableCell>
          <TableCell className={classes.tableHeaderCell}>
            Lunch Start - End
          </TableCell>
          <TableCell className={classes.tableHeaderCell}>Pickups</TableCell>
        </TableRow>
        <TableRow className={classes.tableRow}>
          <TableCell className={classes.tableDataCell}>
          {currentDriverTrailers.length > 1 ? (
              <Select
                classNamePrefix={"select"}
                className={classes.driverPopupSelect}
                value={{
                  label: routeData.trailerNumber,
                  value: routeData.routeId,
                }}
                onChange={changeRouteData}
                menuPlacement="auto"
                menuPosition="absolute"
                closeMenuOnSelect
                isDisabled={currentDriverTrailers.length === 1}
                components={{
                  DropdownIndicator: (props) => (
                    <ArrowDropDown
                      {...props.innerProps}
                      className={classes.iconStyle}
                    />
                  ),
                }}
                options={currentDriverTrailers}
              />
            ) : (
              routeData.trailerNumber
            )}
          </TableCell>
          <TableCell className={classes.tableDataCell}>
          {latestLunchBreak
              ? `${arrivalLunchTime} - ${departureLunchTime}`
              : ""}
          </TableCell>
          <TableCell className={classes.tableDataCell}>
            {`${routeData.completedPickups || 0}/${
              routeData.totalPickups || 0
            }`}
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  );
});

export default Details;
